import React from "react";
import PurchaseOrderDetail from "./PurchaseOrderDetail";

const PurchaseOrderDetailPage: React.FC = () => {
  return <PurchaseOrderDetail />;
};

export default PurchaseOrderDetailPage;
